import { useState } from "react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Card, CardContent } from "./ui/card";
import backgroundImage from "../assets/newsletter.jpg";

export function Newsletter() {
  const [formData, setFormData] = useState({
    firstName: '',
    email: ''
  });
  
  const [isLoading, setIsLoading] = useState(false);
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');

  // Replace these with your actual Mailchimp form details
  const MAILCHIMP_URL = "https://yogivity.us10.list-manage.com/subscribe/post";
  const MAILCHIMP_U = "4c2b1644a63de10dc06798b0b";
  const MAILCHIMP_ID = "36c1ba539a";

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Alternative method using hidden iframe (more reliable)
  const handleSubmitIframe = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setStatus('idle');

    // Create hidden iframe
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.name = 'mailchimp-iframe';
    document.body.appendChild(iframe);

    // Create form
    const form = document.createElement('form');
    form.action = MAILCHIMP_URL;
    form.method = 'POST';
    form.target = 'mailchimp-iframe';
    form.style.display = 'none';

    // Add form fields
    const fields = {
      'u': MAILCHIMP_U,
      'id': MAILCHIMP_ID,
      'FNAME': formData.firstName,
      'EMAIL': formData.email,
      [`b_${MAILCHIMP_U}_${MAILCHIMP_ID}`]: '' // honeypot field
    };

    Object.entries(fields).forEach(([name, value]) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      form.appendChild(input);
    });

    document.body.appendChild(form);
    
    // Handle iframe load (indicates form submission completed)
    iframe.onload = () => {
      setIsLoading(false);
      setStatus('success');
      setFormData({ firstName: '', email: '' }); // Reset form
      
      // Cleanup
      document.body.removeChild(form);
      document.body.removeChild(iframe);
    };

    // Submit form
    form.submit();
  };

  return (
    <section id="newsletter" className="py-24">
      <div className="max-w-7xl mx-auto px-6">
        <Card className="bg-gradient-to-br from-primary/5 to-secondary/30 border-primary/20 relative overflow-hidden min-h-[600px]">
          {/* Background Image */}
          <div
            className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-20"
            style={{ backgroundImage: `url(${backgroundImage})` }}
          ></div>

          {/* Content Overlay */}
          <div className="absolute inset-0 bg-gradient-to-br from-white/55 to-background/35"></div>

          <CardContent className="p-16 relative z-10 flex items-center justify-center min-h-[600px]">
            <div className="max-w-2xl mx-auto text-center space-y-8">
              <div className="space-y-4">
                <h2 className="text-4xl text-foreground">
                  Iratkozz fel a hírlevelemre!
                </h2>
                <p className="text-xl text-muted-foreground">
                  Csatlakozz közösségünkhöz, ahol havonta írok neked e-mailt
                  jógáról, hosszú és minőségi élettartamról, táplálkozásról,
                  valamint elsőként tudhatsz új tartalmakról és programokról.
                </p>
              </div>

              <form onSubmit={handleSubmitIframe} className="flex flex-col gap-4 max-w-md mx-auto">
                <Input
                  type="text"
                  name="firstName"
                  placeholder="Keresztneved"
                  value={formData.firstName}
                  onChange={handleInputChange}
                  className="bg-white border-border"
                  required
                  disabled={isLoading}
                />
                <Input
                  type="email"
                  name="email"
                  placeholder="E-mail címed"
                  value={formData.email}
                  onChange={handleInputChange}
                  className="bg-white border-border"
                  required
                  disabled={isLoading}
                />

                {/* Status Messages */}
                {status === 'success' && (
                  <div className="p-4 bg-green-50 border border-green-200 rounded-lg">
                    <p className="text-green-800 text-sm">
                      ✅ Köszönjük a feliratkozást!
                    </p>
                  </div>
                )}
                
                {status === 'error' && (
                  <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
                    <p className="text-red-800 text-sm">
                      ❌ Hiba történt a feliratkozás során. Próbáld újra később.
                    </p>
                  </div>
                )}

                <Button
                  type="submit"
                  disabled={isLoading}
                  className="bg-primary 
                    text-primary-foreground
                    hover:bg-[#6d5a44]
                    active:bg-[#5a4a38]
                    transition-colors 
                    duration-200
                    transform 
                    hover:scale-[1.02]
                    active:scale-[0.98]
                    shadow-md 
                    hover:shadow-lg
                    hover:shadow-primary/30
                    border 
                    border-primary/20
                    hover:border-primary/40
                    px-8
                    disabled:opacity-50
                    disabled:cursor-not-allowed
                    disabled:transform-none
                    disabled:hover:scale-100"
                >
                  {isLoading ? 'Feliratkozás...' : 'Feliratkozok'}
                </Button>
              </form>

              <div className="space-y-4">
                <p className="text-xs text-muted-foreground">
                  Tiszteletben tartom az adataid védelmét. Bármikor
                  leiratkozhatsz a hírlevelemről.
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>
  );
}